import I18n from 'I18n';
import { useEffect } from 'react';
export const setTitle = title => {
  document.title = title;
};
export const resetTitle = () => {
  const title = I18n.text('pricingPage.windowTitles.default');
  setTitle(title);
};
export const useDocumentTitle = titleKey => {
  const title = I18n.text(`pricingPage.windowTitles.${titleKey}`);
  useEffect(() => {
    setTitle(title);
    return () => resetTitle();
  }, [title]);
};